import {XBrowser} from './globals'
import {getServerTime} from '../utils/base'

const LS_KEY_XSAPP_INFO = 'xs_xsapp_info'

export function saveXSAppInfo(info) {
  const {version, id, type} = info
  const data = {
    id,
    type,
    version,
    mtime: getServerTime()
  }
  XBrowser.setStorage(LS_KEY_XSAPP_INFO, JSON.stringify(data))
  return data
}

export function getXSAppInfo() {
  let info = XBrowser.getStorage(LS_KEY_XSAPP_INFO)
  if (info) {
    try {
      info = JSON.parse(info)
    } catch (e) {
      info = null
    }
  }
  return !!info && info.version ? info : null
}
